export default {
    when() {
        return document.querySelectorAll('.loader-home').length > 0;
    },

    mounted() {
        if (!sessionStorage.getItem('hasVisited')) {
            let loader = document.querySelector('.loader-home');
            loader.classList.remove('hidden');
            loader.classList.add('flex');
            let text = document.querySelector('#dossin-text');
            let image = document.querySelector('#dossin-logo');
          
            setTimeout(function() {
                image.classList.add('animate-slide-in-left');
            }, 200)
            setTimeout(function() {
                text.classList.add('animate-slide-in-right');
            }, 800)
            setTimeout(function () {
                loader.classList.add('animate-slide-out-top');
            }, 2600);
            setTimeout(function () {
                loader.classList.add('hidden');
            }, 5000);
            sessionStorage.setItem('hasVisited', true);
        } 
    },
};
